import(/* webpackMode: "eager" */ "/app/apps/customer-web/src/app/page.tsx");
